export enum OrganizationTypeEnum {
  B2bCustomer = 1,
  B2cCustomer
}